import { Api } from 'utils';

class AuthService {
	
	static login = async (params?: any) => Api.createResponse('auth/login',params);
	static register = async (params?: any) => Api.createResponse('auth/register',params);
	static checkCode = async (params?: any) => Api.createResponse('auth/check-code',params);
	static recover = async (params = {}) => Api.createResponse('auth/recover',params);
	static reset = async (params = {}) => Api.createResponse('auth/reset',params);
	static checkUser = async (params = {}) => Api.createResponse('auth/check-user',params);
	static getDocumentTypes = async (params = {}) => Api.createResponse('auth/document-types',params);
	static resendCode = async (params = {}) => Api.createResponse('auth/resend-code',params);
	static validate = async (params = {}) => Api.createResponse('auth/validation',params);

}

export default AuthService;